import Repository from "../../repository";

export default {
    GetTotalContractByReferenceID: (payload) => Repository.post(`/api/CustomerShippings/GetTotalContractByReferenceID`, payload),
    GetDetailByOIDAndReferenceID: (payload) => Repository.post(`/api/CustomerShippings/GetDetailByOIDAndReferenceID`, payload),
}
